module.exports = __webpack_public_path__ + "media/images/facebook_white-4dd5f33ffba4b5887a14fb795cd98963.png";